var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNdrysho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000150095162948153196110000000343066519361479581_);}\n\t.st3{clip-path:url(#SVGID_00000149373799831424193490000001055284926283052476_);}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#BDB6B8;}\n\t.st6{fill:#1A1A1A;}\n\t.st7{fill:#ADA8AA;}\n\t.st8{fill:#262424;}\n\t.st9{fill:#1E8273;}\n\t.st10{fill:#239281;}\n\t.st11{fill:#262626;}\n\t.st12{fill:#0F0F0F;}\n\t.st13{fill:#212226;}\n\t.st14{opacity:0.25;}\n\t.st15{clip-path:url(#SVGID_00000033336141838956197840000005155688556602492856_);}\n\t.st16{opacity:0.15;}\n\t.st17{clip-path:url(#SVGID_00000069366834107702308560000000590736418139380395_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7431_00000060022719262200020110000009623688766172120195_",
    className: "st0",
    d: "M0,11.2v2.4C0,13.8,0.2,14,0.4,14 c0,0,0,0,0,0h2.4C2.9,14,3,14,3,13.9l8.5-8.5L8.6,2.5L0.1,11C0,11,0,11.1,0,11.2z M13.8,3.1c0.3-0.3,0.3-0.8,0-1.1c0,0,0,0,0,0 L12,0.2c-0.3-0.3-0.8-0.3-1.1,0c0,0,0,0,0,0L9.4,1.7l2.9,2.9L13.8,3.1L13.8,3.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNdrysho);
export default __webpack_public_path__ + "static/media/icon_ndrysho.dd90372e511f6abc22c44af53903280d.svg";
export { ForwardRef as ReactComponent };